/**
 * Tiny logger wrapper — single integration point for error reporting.
 *
 * Today: writes to `console` only in non-production builds (stripped from the
 * production bundle by webpack's dead-code elimination on `NODE_ENV`).
 * Tomorrow: swap the bodies for a real logging service (Sentry, Datadog,
 * LogRocket, etc.) without touching call-sites.
 */

const isProd = process.env.NODE_ENV === "production";

export const log = {
  error: (...args) => {
    if (!isProd) console.error(...args);
  },
  warn: (...args) => {
    if (!isProd) console.warn(...args);
  },
  info: (...args) => {
    if (!isProd) console.info(...args);
  },
};

export default log;
